'use strict';

var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var withStyles = require('../../Styles/withStyles.js');
var Container$2 = require('../../../node_modules/@material-ui/core/esm/Container/Container.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles(theme) {
  return {
    white: {
      backgroundColor: theme.palette.background.white,
      margin: 'auto'
    },
    grey: {
      backgroundColor: theme.palette.background.main,
      margin: 'auto'
    },
    fullScreen: {
      padding: '100px 8px 200px 8px',
      width: '100%',
      margin: 'auto'
    },
    maxWidth: {
      padding: '100px 8px 200px 8px',
      maxWidth: 1250,
      margin: 'auto'
    }
  };
};

var Container = function Container(_ref) {
  var classes = _ref.classes,
      backgroundColor = _ref.backgroundColor,
      pageWidth = _ref.pageWidth,
      children = _ref.children,
      useMaterialContainer = _ref.useMaterialContainer,
      restOfProps = objectWithoutProperties(_ref, ["classes", "backgroundColor", "pageWidth", "children", "useMaterialContainer"]);

  if (useMaterialContainer) {
    return React__default["default"].createElement(Container$2["default"], restOfProps, children);
  }

  return React__default["default"].createElement("div", {
    className: classes[backgroundColor]
  }, React__default["default"].createElement("div", {
    className: classes[pageWidth]
  }, children));
};

Container.defaultProps = {
  backgroundColor: 'grey',
  pageWidth: 'maxWidth'
};
var Container$1 = withStyles["default"](styles)(Container);

module.exports = Container$1;
